import generateDirective from '../generator';
import RatesTermsStageController from './controller';

generateDirective('RatesTerms', '/customer_application_renderer/stages/rates_terms/form.html', RatesTermsStageController);
